<template>
  <b-checkbox-button
    :model-value="value"
    :native-value="nativeValue"
    :type="type"
    @update:model-value="onInput"
  >
    <slot />
  </b-checkbox-button>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CheckboxButtonView',
  emits: ['input'],
  props: {
    value: {
      required: false
    },
    nativeValue: {
      required: false
    },
    type: {
      type: String,
      default: 'is-primary'
    }
  },
  methods: {
    onInput(...args) {
      this.$emit('input', ...args);
    }
  }
};
</script>
